<template>
  <div>
    <table class="table table-xs table-hover">

      <thead>

      <tr>
        <th colspan="5" class=" text-danger">YÖNETİM BİLGİLERİ
          <el-tooltip class="item" effect="dark"
                      content="Online işlem merkezinde özel raporlar alabilir, ayrıca iletişim kısmında gösterilir."
                      placement="top">
            <i class="el-icon-info text-primary cursor-pointer"></i>
          </el-tooltip>
          <button v-if="Yetki"
                  @click="this.Ekle"
                  class="el-button TableBtn el-button--success el-button--mini float-right">İLGİLİ
            EKLE
          </button>
        </th>
      </tr>
      <tr>
        <th width="100">Görevi</th>
        <th width="200">Adı Soyadı</th>
        <th width="100">Telefon</th>
        <th width="200">Mail Adresi</th>
        <th width="50" v-if="Yetki"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="IlgiliDetay in Liste">
        <td>{{IlgiliDetay.Gorev}}</td>
        <td>{{IlgiliDetay.AdSoyad}}</td>
        <td>{{IlgiliDetay.Telefon}}</td>
        <td>{{IlgiliDetay.Mail}}</td>
        <td v-if="Yetki">

          <el-tooltip class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                      placement="top-start">
            <a href="#" @click="Duzenle(IlgiliDetay)" class="text-info mr-1"> <i class="feather-edit-2"></i></a>
          </el-tooltip>
          <el-tooltip class="item" effect="dark"
                      :content="Sayfa.SilAdi"
                      placement="top-start">
            <a href="#" @click="SilOnay(IlgiliDetay.id)" class="text-danger"> <i
              class="el-icon-delete-solid"></i></a>
          </el-tooltip>


        </td>
      </tr>
      </tbody>

    </table>

    <el-form v-if="Ilgili.Form" class="BilgiForm" :rules="IlgiliHata" :model="Ilgili"
             @submit.prevent.native="IlgiliKaydet"
             ref="Ilgili">
      <h2>{{Ilgili.Baslik}} <a @click="Ilgili.Form=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      </h2>

      <el-form-item prop="Gorev">
        <el-input size="mini" type="input" v-model="Ilgili.Gorev">
          <template slot="prepend">Görevi</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="AdSoyad">
        <el-input size="mini" type="input" v-model="Ilgili.AdSoyad">
          <template slot="prepend">Adı Soyadı</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="Telefon">
        <el-input size="mini" type="input" v-mask="'### ### ## ##'" v-model="Ilgili.Telefon">
          <template slot="prepend">Telefon</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="Mail">
        <el-input size="mini" type="input" v-model="Ilgili.Mail">
          <template slot="prepend">Mail</template>
        </el-input>
      </el-form-item>
      <button type="button" @click="IlgiliKaydet" v-if="!lo"
              class="el-button mt-2 YeniBtn el-button--success el-button--mini btn-block">KAYDET
      </button>

    </el-form>
  </div>
</template>


<script>
  export default {
    props: {
      BinaBilgi: Object
    },
    data() {
      return {
        lo: false,
        Sayfa: {
          ButtonAdi: this.$t('eGenel.10'),
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Button: null,
          Adi: this.$t('eYonetim.20.0'),
          Menu: [],
          MenuDisplay: null,
        },
        Yetki: false,
        Liste: [],
        Ilgili: {
          Baslik: 'İlgili Ekle',
          id: null,
          Form: false,
          Gorev: null,
          AdSoyad: null,
          Telefon: null,
          Mail: null,
        },
        IlgiliHata: {
          Gorev: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          AdSoyad: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }

      }
    },
    methods: {
      IlgiliKaydet() {
        this.$refs['Ilgili'].validate((valid) => {
          if (valid) {
            this.lo = true;
            if (this.Ilgili.id) {
              // DÜZENLE
              this.$store.dispatch("Put", {
                ...this.Ilgili,
                path: 'yonetim/bina/ilgili/' + this.Ilgili.id
              })
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$message.success(response.Mesaj);
                    this.Ilgili.Form = false;
                    this.SayfaYukle();
                    this.Ilgili = {
                      Baslik: 'İlgili Ekle',
                      id: null,
                      Form: false,
                      Gorev: null,
                      AdSoyad: null,
                      Telefon: null,
                      Mail: null,
                    }

                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })

            } else {
              // EKLE
              this.$store.dispatch("Post", {
                ...this.Ilgili,
                path: 'yonetim/bina/ilgili/' + this.BinaBilgi.id
              })
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.SayfaYukle();
                    this.$message.success(response.Mesaj);
                    this.Ilgili = {
                      Baslik: 'İlgili Ekle',
                      id: null,
                      Form: false,
                      Gorev: null,
                      AdSoyad: null,
                      Telefon: null,
                      Mail: null,
                    }
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });
      },
      SayfaYukle() {
        if (this.BinaBilgi.id) {
          this.$store.dispatch("Get", {path: 'yonetim/bina/ilgili/' + this.BinaBilgi.id})
            .then(response => {
              if (response.Durum === 'OK') {
                this.Liste = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
        }

        this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
      },
      Ekle() {
        this.Ilgili = {
          Baslik: 'İlgili Ekle',
          id: null,
          Form: true,
          Gorev: null,
          AdSoyad: null,
          Telefon: null,
          Mail: null,
        }
      },
      Duzenle(Veri) {
        this.Ilgili = {
          Baslik: 'İlgili Düzenle',
          id: Veri.id,
          Form: true,
          Gorev: Veri.Gorev,
          AdSoyad: Veri.AdSoyad,
          Telefon: Veri.Telefon,
          Mail: Veri.Mail,
        }
      },
      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/bina/ilgili/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.ModalOlayi = false;
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },

    },
    created() {
      this.SayfaYukle()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Comp/Ilgili.vue